import { Link } from 'react-router-dom';
import { categories } from '@/mocks/manga';

const CATEGORY_ICONS: Record<string, string> = {
  fitness: 'ri-heart-pulse-line',
  youth: 'ri-run-line',
  city: 'ri-building-2-line',
  romance: 'ri-heart-3-line',
  comedy: 'ri-emotion-laugh-line',
  fantasy: 'ri-sword-line',
  suspense: 'ri-spy-line',
};

export default function CategoryNav() {
  return (
    <section className="bg-background-100/70 py-12 md:py-16" aria-label="漫画分类导航">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <span className="text-xs font-medium uppercase tracking-widest text-primary-600">
            Categories
          </span>
          <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">海量漫画分类</h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600">
            健身、热血、都市、恋爱、搞笑……总有一款适合你，点击分类即刻开始免费阅读。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-7">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 rounded-lg bg-background-50 px-3 py-5 text-center transition-all hover:-translate-y-1 hover:bg-primary-500"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-100 text-xl text-primary-600 transition-colors group-hover:bg-background-50/20 group-hover:text-background-50">
                <i className={CATEGORY_ICONS[cat.slug] ?? 'ri-book-2-line'} aria-hidden="true" />
              </span>
              <span className="text-sm font-medium text-foreground-950 transition-colors group-hover:text-background-50">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}